export default "./img/img-e7fb1f.png";